import React, { ReactNode, useEffect, useState } from 'react';
import classNames from 'classnames';
import moment from 'moment';
import { createBrowserHistory } from 'history';
import styles from '../../../assets/provider-tab.module.scss';
import { IProvider } from 'src/types/provider';
import { QueryParams } from 'src/types/grid';
import { Paginated } from 'src/services/api-handlers/pagination';
import { ICase } from 'src/types/case';
import Loader from 'src/components/Loader';
import SimpleCalendar from 'src/components/calendars/SimpleCalendar';
import CaseComponent from '../Detail';
import AccordionComponent from 'src/components/common/Accordion';
import Router from '../../../../../../../../../navigation/router';
import { routes } from '../../../../../../../../../navigation';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { ISeance } from 'src/types/seance';
import { changeToZeroZoneDate } from '../../../../../../../../../helpers/timeHelpers';
import { IInvoice } from '../../../../../../../../../types/invoice';
import CaseEnum from '../../../../../../../../../enumerables/case-enum';
import { getValFromEnum } from '../../../../../../../../../components/redux-form/utils/dropdown-values';

export interface StateProps {
    cases: Paginated<ICase>;
    invoices: Paginated<IInvoice>;
    current: ISeance | null;
    caseData: Partial<ICase> | null;
    providerEntity: { [key: string]: any };
    inProgressAll: boolean;
    inProgress: boolean;
}
export interface DispatchProps {
    getCases: (params: QueryParams) => void;
    getData: (id: string | number) => void;
    getStatistics: (params: any) => void;
    getDataSeance: (params: QueryParams) => void;
    getInvoices: (params: QueryParams) => void;
    getStatementsDocs: (params: QueryParams) => void;
    getCase: (id: string | number) => void;
    getServiceTypes: (params: QueryParams) => void;
    getServiceLocations: (params: QueryParams) => void;
}
interface RouteParams {
    id: string;
    subId: string;
}
export interface OwnProps {
    provider: Partial<IProvider> | null;
    caseId: string;
    seanceId?: string;
}

export interface Props extends StateProps, DispatchProps, OwnProps, RouteComponentProps<RouteParams> {}
const CaseSession: React.FunctionComponent<Props> = (props: Props) => {
    const {
        getCases,
        provider,
        providerEntity,
        getData,
        seanceId,
        getStatistics,
        getDataSeance,
        invoices,
        getServiceLocations,
        getServiceTypes,
        getInvoices,
        getStatementsDocs,
        cases,
        caseId,
        current,
        caseData,
        inProgress,
        getCase,
        inProgressAll,
        history,
        match: {
            params: { subId, id },
        },
    } = props;

    const [tabId, setTab] = useState<string | boolean>(false);
    let monthInit: { monthEnd: string; monthStart: string } = {
        monthStart: moment().startOf('month').format('YYYY-M-D'),
        monthEnd: moment().endOf('month').format('YYYY-M-D'),
    };

    if (current) {
        monthInit = {
            monthStart: moment(changeToZeroZoneDate(current['seanceDate'])).startOf('month').format('YYYY-M-D'),
            monthEnd: moment(changeToZeroZoneDate(current['seanceDate'])).endOf('month').format('YYYY-M-D'),
        };
    }

    const [month, setMonth] = useState<{ monthEnd: string; monthStart: string; change?: boolean }>(monthInit);

    useEffect(() => {
        if (+subId && !+tabId && !month.change) {
            setTab(`${subId}`);
        }
        if (+tabId) {
            getCase(+tabId);
        }
        // eslint-disable-next-line
    }, [tabId]);
    useEffect(() => {
        if (current && seanceId && current.seanceDate && +current.id === +seanceId) {
            setMonth({
                change: true,
                monthStart: moment(changeToZeroZoneDate(`${current.seanceDate}`))
                    .startOf('month')
                    .format('YYYY-M-D'),
                monthEnd: moment(changeToZeroZoneDate(`${current.seanceDate}`))
                    .endOf('month')
                    .format('YYYY-M-D'),
            });
        }
        // eslint-disable-next-line
    }, [current]);
    useEffect(() => {
        if (seanceId) {
            getData(seanceId);
            setTab(`${caseId}`);
        }
        // eslint-disable-next-line
    }, [seanceId]);

    useEffect(() => {
        if (!inProgressAll && !cases.list.length && +tabId) {
            setTab(tabId ? tabId : false);
            historyTemp.push(
                Router.generate(routes.PROVIDER_DETAIL, {
                    tab: 'case-sessions',
                    id: provider?.id,
                    subId: tabId ? tabId : '',
                }),
            );
        }
        if (seanceId && !current) {
        } else {
            if (+tabId && caseData && `${tabId}` === `${caseData.id}`) {
                let isCaseId = false;
                cases.list.forEach((dataCase) => {
                    if (+subId === +dataCase.id || +tabId === +dataCase.id) {
                        isCaseId = true;
                    }
                });

                if (isCaseId && tabId) {
                    getStatistics({ occasion: +tabId, dateFrom: month.monthStart, dateTo: month.monthEnd });
                    getServiceLocations({ page: 1, itemsPerPage: 9000 });
                    getServiceTypes({ page: 1, itemsPerPage: 9000 });
                    getDataSeance({
                        page: 1,
                        filters: {
                            'occasion.id': +tabId,
                            'provider.id': +id,
                            'seanceDate[after]': month.monthStart,
                            'seanceDate[before]': month.monthEnd,
                            'order[seanceDate]': 'asc',
                        },
                        itemsPerPage: 9000,
                    });
                    getInvoices({
                        page: 1,
                        filters: {
                            'occasion.id': +tabId,
                            'periodStart[after]': month.monthStart,
                            'periodStart[before]': month.monthEnd,
                            'provider.id': +id,
                        },
                    });
                    getStatementsDocs({
                        page: 1,
                        filters: {
                            'statement.occasion.id': +tabId,
                            'periodStart[after]': month.monthStart,
                            'periodStart[before]': month.monthEnd,
                            'provider.id': +id,
                        },
                    });
                } else if (cases.list.length) {
                    /* setTab(false);
                    historyTemp.push(
                        Router.generate(routes.PROVIDER_DETAIL, { tab: 'case-sessions', id: provider?.id, subId: '' }),
                    );*/
                }
            }
        }
        // eslint-disable-next-line
    }, [tabId, caseData, cases.list]);

    useEffect(() => {
        if (provider && provider.id) {
            if (seanceId && !current) {
            } else {
                if (current && seanceId && +current.id !== +seanceId) {
                } else {
                    getCases({
                        page: 1,
                        filters: {
                            provider: provider.id,
                            'seanceDate[before]': month.monthEnd,
                            'seanceDate[after]': month.monthStart,
                            //  'order[seanceDate]': 'asc',
                        },
                        itemsPerPage: 9000,
                    });
                }
            }
        }

        // eslint-disable-next-line
    }, [getCases, month]);

    const historyTemp = createBrowserHistory();
    const onChangeDate = (date: Date) => {
        const monthStart = moment(date).startOf('month').format('YYYY-M-D');
        const monthEnd = moment(date).endOf('month').format('YYYY-M-D');
        setMonth({ ...month, monthStart, monthEnd, change: true });
        setTab(tabId ? tabId : false);
        historyTemp.push(
            Router.generate(routes.PROVIDER_DETAIL, {
                tab: 'case-sessions',
                id: provider?.id,
                subId: tabId ? tabId : '',
            }),
        );
    };

    const tabs: { header: string; list: { eventKey: string; title: string; renderComponent: ReactNode }[] }[] = [
        { header: 'DOE', list: [] },
        { header: 'DOE', list: [] },
        { header: 'Private', list: [] },
        { header: 'District', list: [] },
        { header: 'Vendor', list: [] },
        { header: 'Yonkers', list: [] },
    ];

    cases.list.forEach((dataCase) => {
        const typeEnum = CaseEnum ? CaseEnum.getEnum(`OrderType_${dataCase?.caseType}`) : {};

        const orderTypes: SelectObject[] = getValFromEnum(typeEnum);
        let name = '';
        let studentDistrictName = '';
        let caseNumber = '';
        if (dataCase.caseType === 1 || dataCase.caseType === 5) {
            caseNumber = dataCase.caseNumber ? dataCase.caseNumber + ',' : '';
        }
        if (dataCase.caseType === 3) {
            name = dataCase.district ? `${dataCase.district.name}` : 'unknown';
            if (dataCase.student) {
                studentDistrictName = `Student: ${dataCase.student.firstName} ${dataCase.student.lastName}; `;
            }
        } else if (dataCase.caseType === 4) {
            name = dataCase.vendor ? `${dataCase.vendor.name}` : 'unknown';
        } else {
            name = dataCase.student ? `${dataCase.student.firstName} ${dataCase.student.lastName}` : 'unknown';
        }

        let serviceType = dataCase?.serviceType?.title;
        if (!serviceType) {
            serviceType = dataCase?.serviceType?.cpt;
        }
        if (serviceType) {
            serviceType = ' ' + serviceType + ', ';
        }

        const serLocation = dataCase.occasionServiceLocations;
        if (serLocation && serLocation.length) {
            serLocation.sort((a: any, b: any) => {
                return a.id < b.id ? -1 : a.id > b.id ? 1 : 0;
            });
        }
        const orderTypeLabel: SelectObject | undefined | string = orderTypes.find(
            (it) => it.value === dataCase.orderType,
        );
        const orderTypeText = orderTypeLabel ? `${orderTypeLabel.label}, ` : '';

        const serviceLocation =
            serLocation && serLocation.length && serLocation[serLocation.length - 1]?.serviceLocation
                ? `${serLocation[serLocation.length - 1].serviceLocation?.title}`
                : '';

        const titleCase = `${name} (${studentDistrictName}${orderTypeText}${caseNumber}${serviceType}${serviceLocation})`;
        tabs[+dataCase.caseType].list.push({
            eventKey: `${dataCase.id}`,
            title: titleCase,
            renderComponent: () => {
                return (
                    <CaseComponent
                        history={history}
                        provider={providerEntity}
                        providerUrlId={id}
                        cases={cases}
                        invoices={invoices}
                        month={month}
                        idCase={+dataCase.id === +tabId ? tabId : false}
                    />
                );
            },
        });
    });
    let isTabsFill = false;
    tabs.map((itTab) => {
        if (itTab.list) {
            isTabsFill = true;
        }
        itTab.list.sort((a: any, b: any) => {
            return a.title.localeCompare(b.title);
        });
        return itTab;
    });
    const handleSelectTab = (tabPage: string | null) => {
        setTab(`${tabPage}`);
        historyTemp.push(
            Router.generate(routes.PROVIDER_DETAIL, { tab: 'case-sessions', id: provider?.id, subId: tabPage }),
        );
    };

    if (!cases) {
        return (
            <div className={classNames(styles.tabWrap, 'tabWrapSession')}>
                <SimpleCalendar
                    nowDate={changeToZeroZoneDate(moment(month?.monthEnd, 'YYYY-M-D').format())}
                    setDate={(val) => false}
                    navigateDate={onChangeDate}
                    containerClassName={`onlyHeaderDatepicker`}
                    open={'date'}
                    view={'month'}
                />
            </div>
        );
    }

    return (
        <div className={classNames(styles.tabWrap, 'tabWrapSession')}>
            <SimpleCalendar
                nowDate={changeToZeroZoneDate(moment(month?.monthEnd, 'YYYY-M-D').format())}
                setDate={(val) => false}
                navigateDate={onChangeDate}
                containerClassName={`onlyHeaderDatepicker`}
                open={'date'}
                view={'month'}
            />
            {inProgressAll || inProgress ? <Loader /> : null}

            <div className={classNames(styles.tabsSessions, 'caseSessionTab')}>
                {tabs.map((itTab, i) =>
                    itTab.list.length ? (
                        <div key={`ks${i}`} className={classNames(styles.tabsSession)}>
                            <h2 className={'mt-2'}>{itTab.header}</h2>
                            <AccordionComponent
                                tabs={itTab.list}
                                activeTab={`${tabId}`}
                                setTab={handleSelectTab}
                                additionalClass={'card-case'}
                            />
                        </div>
                    ) : null,
                )}
            </div>
        </div>
    );
};

export default withRouter(CaseSession);
